import { useTheme } from '@mui/material/styles';
import grey from "@mui/material/colors/grey";

export const TabsStyles = () => {
  const theme = useTheme();

  return {
    borderBottom: `4px solid ${grey[100]}`,
    marginBottom: "12px",
    '& .GroupsButtons__item': {
      borderBottom: `4px solid ${grey[100]}`,
      borderRadius: 0,
      marginBottom: "-4px",
    },
    '& .GroupsButtons__item.active':{
      backgroundColor: "rgba(0, 0, 0, 0.04)",
      color: theme.palette.primary.light,
      borderColor: theme.palette.primary.light,
    }
  }
}

export const AccountsStyles = {
  '& .MuiBox-root th, & .MuiBox-root td': {
    whiteSpace: 'normal',
    wordWrap: 'break-word',
    maxWidth: '200px',
  },
  '& .MuiTableCell-footer': {
    border: 0,
    maxWidth: 'inherit !important',
  }
}

export const AddButtonStyles = () => {
  const theme = useTheme();

  return {
    alignItems: 'center',
    background: theme.palette.primary.dark,
    borderRadius: '4px',
    marginLeft: '10px',
    color: '#fff',
    padding: '4px 8px 4px 4px',
    fontSize: '.85rem',
    fontWeight: 'bold',
    display: 'flex',
    '&:hover': {
      background: theme.palette.primary.light,
    }
  }
}
